import { Box, Flex } from '@chakra-ui/react';
import ToggleOffThumbIcon from '@/assets/icons/ToggleOffThumbIcon';
import ToggleOnThumbIcon from '@/assets/icons/ToggleOnThumbIcon';
import FaceliftSwitch from '@/components/Atoms/FaceliftSwitch/FaceliftSwitch';
import FaceliftText from '@/components/Atoms/FaceliftText/FaceliftText';
import { useColorMode } from '@/components/ui/color-mode-utils';

const loginBackgroundSvg = '/svgs/loginBackground.svg';

const CenteredCardLayout = ({ children, childrenStyle }: { children: React.ReactNode, childrenStyle?: React.CSSProperties | any }) => {
	const { colorMode, toggleColorMode } = useColorMode();
	const darkMode = colorMode === 'dark';
	return (
		<Box bg="brand.pageBackground">
			<Flex
				w="100vw"
				h="100vh"
				backgroundImage={`url(${loginBackgroundSvg})`}
				backgroundSize="cover"
				backgroundPosition="center 30%"
				backgroundRepeat="no-repeat"
				backgroundAttachment="fixed"
				align="center"
				justify="center"
				position="relative"
				overflow="hidden"
			>
				<Box
					position="relative"
					p={{ base: 4, md: 8 }}
					borderRadius="20px"
					backdropFilter="blur(7px)"
					w={{ base: '400px', md: '450px' }}
					mx={{ base: 1, md: 0 }}
					h={{ base: 'auto' }}
					{...(childrenStyle || {})}
				>
					{children}
				</Box>
				<Flex
					position="absolute"
					bottom={5}
					textAlign="center"
					alignItems="center"
					gap={2}
				>
					<FaceliftText>Switch Theme: </FaceliftText>
					<FaceliftSwitch
						checked={darkMode}
						onCheckedChange={toggleColorMode}
						unCheckedThumbIcon={<ToggleOffThumbIcon />}
						checkedThumbIcon={<ToggleOnThumbIcon />}
					/>
				</Flex>
			</Flex>
		</Box>
	);
};

export default CenteredCardLayout;
